import {
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material'

function MultiSelect({
  value,
  label,
  onChange,
  isLoading,
  options,
}: {
  value: string[]
  label: string
  onChange: (newValue: string | string[]) => void
  isLoading: boolean
  options: {
    label: string
    key: string | number
  }[]
}) {
  const correctOrderOptions = options.map((x) => x.key)
  const alwaysInTheCorrectOrder = (a: string, b: string) => {
    return correctOrderOptions.indexOf(a) - correctOrderOptions.indexOf(b)
  }
  return (
    <FormControl fullWidth size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        disabled={isLoading}
        value={value.sort(alwaysInTheCorrectOrder)}
        label={label}
        multiple={true}
        renderValue={(selected) => selected.join(', ')}
        onChange={(e) => (!isLoading ? onChange(e.target.value) : null)}
        sx={{ fontSize: '0.875rem' }}
      >
        {options.map(({ key, label }) => (
          <MenuItem
            disabled={isLoading}
            key={key}
            value={key}
            sx={{ py: 0.5 }}
          >
            <Checkbox size="small" checked={value.includes(key.toString())} />
            <Typography variant="body2">{label}</Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default MultiSelect
